import { UpdateStoryTopicMeta, UpdateStoryTopicPayload } from 'types/store/UpdateStoryTopic';
import { createAsyncReducer } from 'utils/Redux';

import { updateStoryTopicActions } from '../actions';

export default createAsyncReducer<UpdateStoryTopicMeta, UpdateStoryTopicPayload>(updateStoryTopicActions);
